<div class="expo-details">
    <h2 class="expo-name pointer">
        <a role="button" class="back-button" (click)="goBack()"><i class="fa fa-chevron-circle-left pr-10"
                aria-hidden="true"></i></a>
        {{expoInfo?.name}}
    </h2>
    <div class="row align-items-center justify-content-center">
        <div class="col-12 col-md-7">
            <div id="myCarousel" class="carousel text-center slide mb-20" data-ride="carousel" data-pause="hover">
                <div class="carousel-inner">
                    <ng-container *ngIf="streamAds && eventHomeAdsTop && eventHomeAdsTop.length > 0 ">
                        <div *ngFor="let a of eventHomeAdsTop; let i=index" class="adv-img1 carousel-item"
                            id="{{a.duration}}" [innerHtml]=a.image [ngClass]="{'active' : i == 0}">
                        </div>
                        <div class="ad-position">
                            <span class="icon-bg "><a class="text-center" [href]="selectedAdData" target="_blank" class="mr-2 text-white text-decoration-none">Learn more <i class="fa fa-external-link fs-9 ml-1" ></i></a></span> 
                        </div>
                    </ng-container>
                </div>
            </div>
        </div>
       
    </div>
    <div class="row no-gutters">
        <div class="col-12 col-md-8 col-lg-9">
            <div class="details-area">
                <!-- Banner Section Start -->
                <div class="banner" [style.background-image]="'url(' + expoInfo?.banner + ')'">
                </div>
                <!-- Banner Section End -->

                <!-- profile Section Start -->

                <div class="expo-details-content">
                    <div class="profile-div w-100">
                        <div class="row no-gutters align-items-center">
                            <div class="col-5 col-md-3 col-lg-3 w-200">
                                <div class="event-image" [style.background-image]="'url(' + expoInfo?.logo + ')'">
                                </div>
                                <!-- <img [src]=expoInfo?.logo alt="" class="img-fluid event-image"> -->
                            </div>
                            <div class="col-7 col-md-8 col-lg-8">
                                <div class="event-stage-name">
                                    {{expoInfo?.name}}
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Description Div Start -->
                    <div>
                        <h3 class="details-content-headings description-heading"> description</h3>
                        <div class="row description">
                            <div class="col-12 col-md-8 col-lg-9">
                                <p class="desc-box">
                                    {{expoInfo?.about}}
                                </p>
                            </div>
                            <div class="col-12 col-md-4 col-lg-3">
                                <div>
                                    <h6 class="connect-with">
                                        Connect With Us
                                    </h6>

                                    <a [href]=expoInfo?.url target="_blank">
                                        <i class="fa fa-globe connect-globe" aria-hidden="true"></i>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Description Div End -->
                    <div *ngIf="expoInfo?.document">
                        <h3 class="details-content-headings "> Resources </h3>

                        <div class="broucher-div">
                            <a [href]=expoInfo?.document class="broucher btn-secondary align-middle"
                                target="_blank">Brochure</a>
                            <a [href]=expoInfo?.document class="broucher broucher-img btn-secondary align-middle"
                                target="_blank">
                                <i class="fa fa-external-link" aria-hidden="true"></i></a>
                        </div>
                    </div>

                    <div *ngIf="expoInfo?.video">
                        <h3 class="details-content-headings "> Videos </h3>
                        <div class="row">
                            <div class="col-12 col-md-6 mt-20">
                                <!-- <div class="videos">
                                    <video [src]=expoInfo?.video alt="" class="video-image">
                                    </video>
                                    <a [href]=expoInfo?.video target="_blank"><i class="fa fa-youtube-play"
                                            aria-hidden="true"></i></a>

                                </div> -->
                                <ng-container  *ngIf="isYoutubeVideo">
                                    <iframe width="100%" height="300px" [src]="expoInfo?.video | safe: 'resourceUrl'" frameborder="0" allowfullscreen class="bg-banner">
                                    </iframe>
                                </ng-container>
                                <ng-container *ngIf="!isYoutubeVideo">
                                    <video controls  class="video bg-banner w-100"
                                    controlsList="nodownload">
                                    <source src="{{ expoInfo?.video }}" type="video/mp4" />
                                    </video>
                                </ng-container>
                            </div>
                        </div>


                    </div>
                </div>

                <!-- Profile Section End -->
            </div>
        </div>
        <div class="col-12 col-md-4 col-lg-3">
            <div class="session-area">
                <h3 class="details-content-headings session-heading"> Sessions </h3>

                <div class="room" *ngFor="let r of rooms">
                    <h6 class="room-heading">{{r?.room_name}}</h6>
                    <div class="room-desc">
                        {{r?.room_desc}}
                    </div>
                    <div class="room-desc" *ngFor="let rr of r.expo_timings">
                        {{rr?.start_date_time_final}} -
                        {{rr?.end_date_time_final}}</div>
                    <div class="agent">
                        <span class="align-middle"><img [src]=expoInfo.logo alt=""
                                class="rounded-circle agent-image img-fluid"></span>
                        <span class="align-middle agent-name"> {{r?.agent_name}} </span>
                    </div>
                    <button mat-flat-button class="flat-primary-button secondary-bg-button"
                        (click)="joinRoom(r?.skreens_access_key,expoInfo.id,r?.id)" *ngIf="r?.room_status==1">
                        Join Room</button>
                    <button mat-flat-button class="flat-primary-button secondary-bg-button" (click)="contact(r?.id)"
                        *ngIf="r?.room_status!=1">
                        contact</button>
                </div>
            </div>
        </div>
    </div>
</div>






<!-- <div fxFlex="100%" fxLayout="row wrap" class="app-expo-details">
    <div fxFlex="65%" fxLayout="row wrap">
        <div fxFlex="100%" class="top-bar">
            <div fxFlex="60%"> -->
<!-- <img src="assets/1.jpg" class="user-img" /> -->
<!-- <div fxFlex="20%" fxLayout="row" fxLayoutAlign="center center" >
                    <div class="user-section"></div>
                </div>
                <div fxFlex="80%" fxLayout="row" fxLayoutAlign="Start center" >
                    <div> Startup 1 Live Event</div>
                </div>

            </div>
            <div fxFlex="40%" fxLayout="row" fxLayoutAlign="center center"  class="f-r icons">
                Icons
            </div>
        </div>
        <div fxFlex="100%">
            <img src="assets/1.jpg" class="section-img" />
        </div>
    </div>
    <div fxFlex="35%" fxLayout="row wrap">
        <mat-tab-group fxFlex="100%"> -->
<!-- Non Subscription START -->
<!-- <mat-tab label="Booth">

            </mat-tab>
            <mat-tab label="Live Video Chat Rooms">
                <div class="mt-10 p-20">
                    <div class="room-head pb-10">
                        Room Name
                    </div>
                    <div class="room-title mb-20">
                        Lorem Name
                    </div>
                    <div class="room-head pb-10">
                        Room Description
                    </div>
                    <div class="room-title mb-20">
                        Lorem Desc
                    </div>
                    <div class="room-head pb-10">
                        Agent Name
                    </div>
                    <div class="room-title mb-20">
                        Lorem Agent
                    </div>
                    <button mat-flat-button class="square-btn">Join Room</button>
                </div>
            </mat-tab>
        </mat-tab-group>
    </div>
</div> -->